<template>
  <div :class="[$style.card]">
    <PImage :image-object="item.media_logo" :class="$style.mediaLogo" />
    <RichText :text-params="item.media_content" :class="$style.mediaContent" />
    <PLink
      v-if="item.media_link_url"
      :link-object="item.media_link_url"
      :class="$style.link"
      is-highlight
      target="_blank"
      color="bluko-200"
    >
      {{ item.media_link_text }}
    </PLink>
  </div>
</template>

<script>
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'

export default {
  name: 'MediaCard',
  components: {
    RichText,
    PLink,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.card {
  min-height: 350px;
  margin: 0 20px;
  padding: 32px 40px;
  border-radius: 8px;

  background-color: $bluko-700;

  transition: opacity 0.4s ease-in 0.2s;
}

.mediaLogo {
  height: 32px;
  margin-bottom: 30px;
}
.mediaContent {
  @include typo-headline;
}
.link {
  display: flex;
  align-items: center;
  margin-top: 24px;

  color: $bluko-200;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.icon {
  margin-right: 5px;
}
</style>
